import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { withNamespaces } from 'react-i18next';
import ListWage from './ListWage';
import ListDistributedDocuments from './ListDistributedDocuments';
import * as documentType from '../../scripts/DocumentTypeCode';
import * as documentFolder from '../../scripts/DocumentFolderCode';
import { getAccessTab } from '../../utils/menuHelper';
import * as keyMenu from '../../scripts/KeyMenu';


function TabPanelWage(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanelWage.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function ScrollableTabsButtonForce({ t }) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [hasPayStubs, setHasPayStubs] = React.useState(false);
    const [hasYearEnd, setHasYearEnd] = React.useState(false);
    const [hasDocuments, setHasDocuments] = React.useState(false);

    useEffect(() => {
        const access = validateAccessTab();

        activateInitialTab(access);
    }, []);

    const validateAccessTab = () => {
        const isTabPayStub = getAccessTab(keyMenu.TAB_PAYSTUBS);
        const isTabYearEnd = getAccessTab(keyMenu.TAB_YEAREND);
        const isTabDocument = getAccessTab(keyMenu.TAB_DOCUMENTS);

        setHasPayStubs(isTabPayStub);
        setHasYearEnd(isTabYearEnd);
        setHasDocuments(isTabDocument);

        const access = { isTabPayStub, isTabYearEnd, isTabDocument };

        return access;
    }

    const activateInitialTab = (access) => {
        if (access.isTabPayStub) {
            setIndex(0);
        } else if (access.isTabYearEnd) {
            setIndex(1);
        } else if (access.isTabDocument) {
            setIndex(2);
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const listClick = () => {
        setIndex(0);
    }

    const taxClick = () => {
        setIndex(1);
    }

    const otherClick = () => {
        setIndex(2);
    }

    return (
        <React.Fragment>
            <div data-id="headerSchedule" className={classes.root}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        {hasPayStubs && <Tab className={"TabPageButton"} label={t('wage:tabPanel.wage')} {...a11yProps(0)} onClick={listClick} />}
                        {hasYearEnd && <Tab className={"TabPageButton"} label={t('wage:tabPanel.tax-documents')} {...a11yProps(1)} onClick={taxClick} />}
                        {hasDocuments && <Tab className={"TabPageButton"} label={t('wage:tabPanel.other-documents')} {...a11yProps(2)} onClick={otherClick} />}
                    </Tabs>
                </AppBar>
            </div>
            {index == 0 && hasPayStubs && <ListWage documentType={documentType.Type_Slip} documentFolder={documentFolder.Type_Slip} />}
            {index == 1 && hasYearEnd && <ListWage documentType={documentType.Type_T4} documentFolder={documentFolder.Type_T4} />}
            {index == 2 && hasDocuments && <ListDistributedDocuments />}
        </React.Fragment>
    );
}

export default withNamespaces(['wage'], { wait: true })(ScrollableTabsButtonForce);